const e = { Undefined: "Undefined", Enabled: "Enabled", Disabled: "Disabled" }, n = { Enable: "Enable", Disable: "Disable" };
export {
  n as GasPipelineSectionAction,
  e as GasPipelineSectionStatus
};
//# sourceMappingURL=types.js.map
